import { environment } from '@environments/environment';

export const GET_PROMOTIONS_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_promotions ?? '',
  body: {
    size: 1,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    _source: ['contenu_promo', 'banner', 'hero_slider_promo', 'date_start', 'date_end'],
  },
});
